import { FC } from 'react';

import { FooterTelegramStyled } from './Footer.styles';

export const TelegramLink: FC = () => (
	<FooterTelegramStyled>
		<img
			style={{ width: `15px`, height: `15px` }}
			alt='telegram logo'
			src='https://cdn.dodostatic.net/static/marketplace/telegram'
		/>
	</FooterTelegramStyled>
);
